<template>
  <section>
    <div class>
      <!-- <div class="title">填写并核对订单信息</div> -->
      <div class="jiesuanbox">
        <div class="jstit">
          <span class="tit fl">收货人信息</span>
          <a href="javascript:;" class="fr color-primary" @click="addadr">新增收货地址</a>
        </div>
        <div class="adrlist">
          <div
            v-for="(item,index) in addressList"
            :key="index"
            :class="index==0 ? 'item active' : 'item' "
          >
            <div class="adr-name" @click="chooseAddress(item.id,item.districtid)">{{item.username}}</div>
            <div class="adr-detail">
              <!-- <span class="name">{{item.username}}</span> -->
              <span class="info">
                 {{item.prov}} {{item.city}} {{item.dist}}
                {{item.address}}
              </span>
              <span class="tel">{{item.username}}({{item.telephone}})</span>
            </div>
            <div class="adr-btns">
              <a href="javascript:;" @click="defaultAdress(item.id)">设为默认地址</a>
              <a href="javascript:;" @click="writerAdress(item)">编辑</a>
              <a href="javascript:;" @click="deteleAddress(item.id)">删除</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="adrpop" class="adrpop" style="display: none;">
      <form class="layui-form" lay-filter="address" action="#/jiesuan">
        <div class="layui-form-item">
          <label class="layui-form-label">收货人</label>
          <div class="layui-input-block">
            <input
              type="text"
              name="username"
              lay-verify="required"
              placeholder="请输入收货人姓名"
              autocomplete="off"
              class="layui-input"
            />
          </div>
        </div>
        <div class="layui-form-item">
          <label class="layui-form-label">手机号码</label>
          <div class="layui-input-block">
            <input
              type="text"
              name="telephone"
              lay-verify
              maxlength="11"
              placeholder="手机号码"
              autocomplete="off"
              class="layui-input"
            />
          </div>
        </div>

        <div class="layui-form-item" id="diqu">
          <label class="layui-form-label">地区</label>
          <div class="layui-input-block">
            <input type="hidden" name="districtid" id="districtid" />
            <input
              type="text"
              class="layui-input"
              data-toggle="city-picker"
              id="districtidswitch"
              placeholder="选择所在地"
              disabled
              data-id="districtid"
              style="width: 630px;"
              value
            />
          </div>
        </div>
        <!--  -->
        <div class="layui-form-item">
          <label class="layui-form-label">详细地址</label>
          <div class="layui-input-block">
            <textarea
              rows="3"
              name="address"
              lay-verify="required"
              placeholder="填写详细地址"
              class="layui-textarea"
            ></textarea>
          </div>
        </div>
        <div class="layui-form-item">
          <label class="layui-form-label"></label>
          <div class="layui-input-block">
            <input type="checkbox" name="isdefault" title="设为默认地址" lay-skin="primary" />
          </div>
        </div>
        <div class="layui-form-item">
          <label class="layui-form-label"></label>
          <div class="layui-input-block">
            <button type="primary" lay-submit lay-filter="address" class="layui-btn">保存</button>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
layui.use(["layer"], function() {
  layer = layui.layer;
});
export default {
  name: "Address",
  data() {
    return {
      addressModal: {},
      addressid: "",
      districtid: "",
      addressList: [1, 2, 3, 4] //收货地址的数据
    };
  },
  watch: {
    districtid() {
      console.log("dsmkgvndofn o");
      this.$emit("watchaddress", {
        districtid: this.districtid,
        addressid: this.addressid
      });
    }
  },
  methods: {
    // 获取地址列表
    async getaddressList() {
      let res = await this.$fetch("Member/address", {
        body: {
          act: "list",
          page: 1,
          size: 50
        }
      });

      this.addressList = res.data;
      if(res.data.length>0){
         this.districtid = res.data[0].districtid;
        this.addressid = res.data[0].id;
      }
     
      // 选中默认地址
    },

    async Addaddress(obj) {
      let res = await this.$fetch("Member/address", {
        body: {
          guid: this.guid,
          act: "save",
          data: obj
        }
      });
      if (res) {
        layer.alert("保存成功", { icon: 1 });
        layer.close(this.addressModal);
        this.getaddressList();
      }
    },
    //点击编辑按钮
    writerAdress(item) {
      console.log(item);
      let that = this;
      $("#districtidswitch").val(item.prov + "/" + item.city + "/" + item.dist);
      $('[data-toggle="city-picker"]')
        .citypicker("destroy")
        .citypicker();
      layui.use(["form", "layer"], function() {
        var form = layui.form;
        var layer = layui.layer;
        //表单初始赋值
        form.val("address", {
          username: item.username,
          telephone: item.telephone,
          districtid: item.districtid,
          address: item.address
        });
        that.addressModal = layer.open({
          title: "编辑收货地址",
          area: "800px",
          type: 1,
          content: $("#adrpop")
        });
        form.on("submit(address)", function(data) {
          let obj = data.field;
          obj["id"] = item.id;
          obj["region"] = obj.prov + "," + obj.city + "," + obj.dist;
          if (!obj.isdefault) {
            obj["isdefault"] = 0;
          } else {
            obj.isdefault = 1;
          }
          that.Addaddress(obj);
          return false;
        });
      });
    },
    // 点击删除地址的按钮
    async deteleAddress(id) {
      let res = await this.$fetch("Member/address", {
        body: {
          guid: this.guid,
          act: "delete",
          data: { id }
        }
      });
      if (res) {
        layer.alert("删除成功", { icon: 1 });
        this.getaddressList();
      }
      // this.getCarlist();
    },
    // 选择收货地址
    chooseAddress(id, districtid) {
      console.log("fsmfnsdv");
      this.addressid = id;
      this.districtid = districtid;

      // this.getCarlist();
    },

    // 设为默认地址
    async defaultAdress(id) {
      let res = await this.$fetch("member/setaddress", { body: { id } });
      this.getaddressList();
      // this.getCarlist();
    },
    // 新增收货地址
    addadr() {
     
      //  function addadr() {
      let that = this;
      $("#districtidswitch").val("" + "/" + "" + "/" + "");
      $('[data-toggle="city-picker"]')
        .citypicker("destroy")
        .citypicker();
      layui.use(["form", "layer"], function() {
        var form = layui.form;
        var layer = layui.layer;
        //表单初始赋值
        form.val("address", {
          username: "",
          telephone: "",
          prov: "",
          city: "",
          dist: "",
          address: ""
        });
        that.addressModal = layer.open({
          title: "添加收货地址",
          area: "800px",
          type: 1,
          content: $("#adrpop")
        });
        form.verify("address", {
          //自定义验证
          // title: function(value){
          //   if(value.length < 5){
          // 	return '标题至少得5个字符啊';
          //   }
          // }
        });
        form.on("submit(address)", function(data) {
          let obj = data.field;
          obj["region"] = obj.prov + "," + obj.city + "," + obj.dist;
          if (!obj.isdefault) {
            obj["isdefault"] = 0;
          } else {
            obj.isdefault = 1;
          }
          that.Addaddress(obj);
          return false;
        });
      });
      // }
    }
  },

  async mounted() {
    this.getaddressList();

    $(".adrlist .item .adr-name").on("click", function() {
      $(this)
        .parent()
        .addClass("active")
        .siblings()
        .removeClass("active");
    });
  }
};
</script>

  


<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/address.vue